import { CircularProgress, Stack } from '@mui/joy';
import React, { FC } from 'react';

const Loading: FC<{ size?: number; dimmed?: boolean }> = ({ size = 100, dimmed = true }) => {
  return (
    <Stack
      position={'absolute'}
      left={0}
      top={0}
      right={0}
      bottom={0}
      justifyContent={'center'}
      alignItems={'center'}
      zIndex={1}
      sx={{
        backgroundColor: dimmed ? 'rgb(206 206 206 / 25%)' : 'transparent',
      }}>
      <CircularProgress
        sx={{
          '--CircularProgress-size': `${size}px`,
        }}
      />
    </Stack>
  );
};

export default Loading;
